import React, { Component } from 'react'

class Importance extends Component<any, any> {
  render() {
    return <div>Importance</div>
  }
}

export default Importance
